import { Collection } from "authory-api-types/dist/types";
import { CCPCollectionBadge, CCPCollectionsWrapper } from "./ContentCollectionsPanel.styles";
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35";
import { V3IconClose } from "../Icons";
import { V3Dropdown } from "../Dropdown";
import { AddToCollectionDropdownPanel } from "../AddToCollectionDropdownPanel";
import Link from "next/link";
import { APPLICATION_ROUTES } from "../../types/routes";
import { UnstyledInlineLink } from "../ReusableStyledComponents/UnstyledLink";
import { V3BlueRoundPlus } from "../ReusableStyledComponents/V3BlueRoundPlus";
import { V3Tooltip } from "../Tooltip";
import { V3TertiaryButton } from "../Button";

interface ContentCollectionsPanelProps {
    allCollections: Collection[],
    contentCollections: Collection[],
    addOrRemoveItemManuallyFromCollection: (add: boolean, collectionSlug: string) => void,
    noCta?: boolean
}

export const ContentCollectionsPanel = ({ allCollections, contentCollections, addOrRemoveItemManuallyFromCollection, noCta = false }: ContentCollectionsPanelProps) => {

    const collectionToAdd = allCollections.filter(cl => !contentCollections.find(ccl => ccl.canonicalSlug === cl.canonicalSlug));

    return <CCPCollectionsWrapper>
        {
            contentCollections.map(col => <CCPCollectionBadge key={col.canonicalSlug} $noCta={noCta}>
                <div>
                    <V3Tooltip
                        referenceContent={<Link href={`${APPLICATION_ROUTES.COLLECTION}/${col.canonicalSlug}`} passHref legacyBehavior>
                            <UnstyledInlineLink>
                                <V3CaptionGrey35>{col.label}</V3CaptionGrey35>
                            </UnstyledInlineLink>
                        </Link>}
                        tooltipContent={"Go to the collection"}
                    />
                </div>
                <div
                    onClick={() => {
                        addOrRemoveItemManuallyFromCollection(false, col.canonicalSlug);
                    }}
                >
                    <V3Tooltip
                        referenceContent={<V3IconClose width="10" height="10" strokeWidth="4" />}
                        tooltipContent={"Remove from collection"}
                    />
                </div>
            </CCPCollectionBadge>)
        }
        {
            !!collectionToAdd.length && <div style={{ margin: '5px 6px', lineHeight: 0 }}>
                <V3Dropdown
                    title="Add collection"
                    strategy="fixed"
                    placement="bottom-end"
                    shiftPadding={80}
                    renderPopperElement={(_, setOpen) => {
                        return <AddToCollectionDropdownPanel
                            collections={collectionToAdd}
                            onCollectionClick={(collectionSlug) => {
                                addOrRemoveItemManuallyFromCollection(true, collectionSlug);
                                setOpen(false);
                            }}
                        />
                    }}
                    renderReferenceElement={(open) => {

                        const Elem = () => <>
                            <V3TertiaryButton
                                icon={<V3BlueRoundPlus />}
                                text={!!contentCollections.length ? "" : "Add to collection"}
                                type="button"
                            />
                        </>

                        if (open) {
                            return <Elem />;
                        }

                        return <V3Tooltip
                            referenceContent={<Elem />}
                            tooltipContent={"Add to collection"}
                        />
                    }}
                />

            </div>
        }
    </CCPCollectionsWrapper>
}